export const SitecoreServer: LXS.SitecoreServer =
    typeof SitecoreServerInternal === "object"
        ? SitecoreServerInternal
        : { isExperienceEditor: false, isExperienceEditorEditing: false };
